import React from 'react';
import { classes } from 'utils';

import styles from './Grid.module.scss';

const Grid = props => {
  const { width, minWidth, maxWidth, className, spacing = 0, children } = props;

  return (
    <div
      className={classes(styles.grid, className)}
      style={{ width, minWidth, maxWidth, padding: spacing }}
    >
      {children}
    </div>
  );
};

export default Grid;
